export class CancellationTerms {
  defaultTerms: boolean;
  terms: string;
  emptyLegTerms: string;
  dynamicDepartureTerms: string;

  getDefaultTerms(): boolean {
    return this.defaultTerms;
  }

  setDefaultTerms(value: boolean): CancellationTerms {
    this.defaultTerms = value;

    return this;
  }

  getTerms(): string {
    return this.terms;
  }

  setTerms(terms: string): CancellationTerms {
    this.terms = terms;

    return this;
  }

  getEmptyLegTerms(): string {
    return this.emptyLegTerms;
  }

  setEmptyLegTerms(emptyLegTerms: string): CancellationTerms {
    this.emptyLegTerms = emptyLegTerms;

    return this;
  }

  getDynamicDepartureTerms(): string {
    return this.dynamicDepartureTerms;
  }

  setDynamicDepartureTerms(dynamicDepartureTerms: string): CancellationTerms {
    this.dynamicDepartureTerms = dynamicDepartureTerms;

    return this;
  }

}
